/* istanbul ignore file */

// declarative file
export const ApiErrorReasons = {
  ATTACHMENT_ERROR:
    'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  ATTACHMENT_INVALID_FORMAT:
    'Le format du fichier envoyé n’est pas autorisé, veuillez respecter les formats autorisés',
  ATTACHMENT_TOO_LARGE:
    'La taille du fichier envoyé est trop importante, veuillez respecter la taille maximale autorisée',
  BAD_REQUEST: 'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  INTERNAL_SERVER_ERROR:
    'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  INVALID_EMAIL: 'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  INVALID_INPUT: 'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  INVALID_TYPE: 'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  LIMIT_EXCEEDED:
    'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  REQUEST_EMPTY_BODY:
    'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  SMTP_CONNECT_FAILED:
    'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
  UNKNOWN_INPUT_TYPE:
    'Le traitement de votre demande n’a pas abouti, veuillez réessayer ultérieurement',
};
